const IconTelegram = () => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66866 11.0269C9.23205 9.05119 12.275 7.74867 13.7976 7.11936C18.1448 5.32254 19.0481 5.01042 19.6369 5.00011C19.7664 4.99784 20.0559 5.02973 20.2435 5.18096C20.4018 5.30866 20.4454 5.48116 20.4663 5.60223C20.4871 5.7233 20.5131 5.9991 20.4924 6.2146C20.2569 8.6743 19.2375 14.6433 18.7189 17.3983C18.4995 18.564 18.0674 18.9548 17.6492 18.9931C16.7401 19.0762 16.0498 18.3961 15.1694 17.8225C13.7916 16.9251 13.0133 16.3664 11.676 15.4907C10.1305 14.4786 11.1323 13.9223 12.0131 13.0132C12.2436 12.7753 16.2489 9.15509 16.3264 8.82668C16.3361 8.7856 16.3451 8.6325 16.2536 8.55166C16.1621 8.47081 16.027 8.49846 15.9295 8.52045C15.7913 8.55161 13.5904 9.99723 9.32663 12.8573C8.7019 13.2836 8.13604 13.4913 7.62904 13.4804C7.07012 13.4684 5.99499 13.1664 5.19573 12.9082C4.21541 12.5915 3.43627 12.4241 3.50412 11.8863C3.53946 11.6062 3.92764 11.3197 4.66866 11.0269Z"
      fill="currentColor"
      data-icon="icon-telegram"
    />
  );
};

export default IconTelegram;
